import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => {
  const { t } = useTranslation('notFound');
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>{t('title')}</h1>
      <p>{t('desc')}</p>
      <Link to="/" style={{ color: 'blue', textDecoration: 'underline' }}>
        {t('backToHome')}
      </Link>
    </div>
  );
};

export default NotFoundPage;
